import { clampLevel } from '../games/colors-levels'
import {
  DEFAULT_DURATION_MINUTES,
  isDurationMinutes,
  type DurationMinutes,
} from '../games/types'

const MUTED_KEY = 'bechoi.muted'
const DURATION_KEY = 'bechoi.durationMin'
const GUIDED_KEY = 'bechoi.guidedAccessSeen'
export const COLORS_LEVEL_KEY = 'bechoi.colors.level'

export type Settings = {
  muted: boolean
  durationMin: DurationMinutes
}

export function loadSettings(): Settings {
  return {
    muted: readMuted(),
    durationMin: readDuration(),
  }
}

export function saveMuted(muted: boolean): void {
  localStorage.setItem(MUTED_KEY, muted ? '1' : '0')
}

export function saveDurationMin(durationMin: DurationMinutes): void {
  localStorage.setItem(DURATION_KEY, String(durationMin))
}

export function loadGuidedAccessSeen(): boolean {
  return localStorage.getItem(GUIDED_KEY) === '1'
}

export function saveGuidedAccessSeen(): void {
  localStorage.setItem(GUIDED_KEY, '1')
}

export function loadColorsLevel(): number {
  const raw = Number(localStorage.getItem(COLORS_LEVEL_KEY))
  return clampLevel(raw)
}

export function saveColorsLevel(level: number): void {
  localStorage.setItem(COLORS_LEVEL_KEY, String(clampLevel(level)))
}

export function resetColorsLevel(): void {
  saveColorsLevel(1)
}

function readMuted(): boolean {
  return localStorage.getItem(MUTED_KEY) === '1'
}

function readDuration(): DurationMinutes {
  const raw = Number(localStorage.getItem(DURATION_KEY))
  return isDurationMinutes(raw) ? raw : DEFAULT_DURATION_MINUTES
}
